/**
 * GeoService.
 * Toimii rajapintana käyttäjän sijainnin määrityksessä.
 * Tältä palvelulta voi kysyä käyttäjän sijaintia.
 */
app.factory("GeoService",
	["$http", "$timeout", "$rootScope", function($http, $timeout, $rootScope) {

		var requestCallbacks = [];
		var self = this;
		this.statusType = {
			UNINITIALIZED: -1,
			RESOLVING: 0,
			RESOLVED: 1,
			UNAVAILABLE: 2,
			DENIED: 3
		};

		this.status = this.statusType.UNINITIALIZED;
		this.position = undefined;

		function OnGetPosition(position) {
			$rootScope.$apply(function() {

				console.log("GEO", position);
				var coords = null;
				if(position.coords) {
					coords = position.coords;
					self.position = position;
					self.status = self.statusType.RESOLVED;
				}
				else if(position.PERMISSION_DENIED) {
					self.status = self.statusType.DENIED;
				}
				else {
					self.status = self.statusType.UNAVAILABLE;
				}
				for(var i = 0; i < requestCallbacks.length; i++) {
					if(typeof requestCallbacks[i] == 'function') {
						requestCallbacks[i](coords);
					}
				}
				requestCallbacks.length = 0;

			});
		}

		/**
		 * Pyytää sijaintia. Jos sijainti saadaan, callbackille annetaan parametrinä
		 * koordinaatit (Position.coords), jos sijaintia ei saada, annetaan parametrinä null.
		 * Huomaa, että operaatio on async, ja suoritus voi kestää niin kauan kuin
		 * GPS-sijainnin haku vaan voi kestää.
		 * @param callback
		 * @constructor
		 */
		this.RequestPosition = function(callback) {
			if(this.status == this.statusType.DENIED) {
				callback(null);
			}
			else if(this.position) {
				callback(this.position.coords);
			}
			else {
				if ('geolocation' in navigator) {
					requestCallbacks.push(callback);
					// Tämä triggeröi allow/deny -kysymyksen selaimelta.
					this.status = this.statusType.RESOLVING;
					navigator.geolocation.getCurrentPosition(OnGetPosition, OnGetPosition);
				}
				else {
					this.status = this.statusType.UNAVAILABLE;
				}
			}
		};

		this.CancelRequest = function(suppressCallbacks) {
			this.status = this.statusType.UNAVAILABLE;
			if(!suppressCallbacks) {
				for(var i = 0; i < requestCallbacks.length; i++) {
					if(typeof requestCallbacks[i] == 'function') {
						requestCallbacks[i](null);
					}
				}
			}
			requestCallbacks.length = 0;
		};


		return this;
	}]
);